import React, { Component } from "react";
import Fade from "react-reveal";

class Footer extends Component {
  render() {
    if (!this.props.data) return null;

    return (
      <footer>
        <div className="row">
          <Fade duration={600}>
            <div className="twelve columns">
              <ul className="copyright">
                <li>&copy; {new Date().getFullYear()} bob-salon</li>
                <li>
                  <a href="./impressum.html">impressum</a>
                </li>
                <li>
                  <a href="./datenschutz.html">datenschutz</a>
                </li>
              </ul>
            </div>
          </Fade>

          <div id="go-top">
            <a className="smoothscroll" title="Back to Top" href="#home">
              <i className="icon-up-open"></i>
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
